<template>
    <v-card v-bind="$attrs" v-on="{ click }">
        <v-img v-if="src" v-bind="{ ...$attrs }" :src="src"></v-img>
        <v-sheet v-else color="grey lighten-3">
            <v-responsive :aspect-ratio="1 / 1" class="d-flex text-center align-center">
                <v-icon color="grey">mdi-image</v-icon>
            </v-responsive>
        </v-sheet>
        <v-file-input v-model="file" ref="fileInput" v-bind="$attrs" class="d-none" @change="emit"></v-file-input>
    </v-card>
</template>

<script>
import ImagePopup from "./image-popup.vue";

export default {
    components: {
        ImagePopup,
    },
    props: {
        value: { type: [String, Object, File], default: null },
    },
    data: () => ({
        file: null,
        showsMenu: false,
    }),
    computed: {
        src() {
            if (this.file instanceof File) return URL.createObjectURL(this.file);
            else return this.file;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.file = this.value;
        },
        emit() {
            this.$emit("input", this.file);
        },
        click() {
            if (this.file) this.showsMenu = !this.showsMenu;
            else this.$refs.fileInput.$el.getElementsByTagName("input")[0].click();
        },
        remove() {
            this.file = null;
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped >
</style>